import { Component, Input } from '@angular/core';
import { ITableColumn } from 'app/main/shared/shared/table/table-column';
import { IPlaybooksItemDTO } from '../../../dto/playbooks-listening.dto';

@Component({
  selector: 'app-playbook-owner',
  standalone: true,
  imports: [],
  templateUrl: './playbook-owner.component.html',
  styleUrl: './playbook-owner.component.scss'
})
export class PlaybookOwnerComponent {
    @Input() dataItem: IPlaybooksItemDTO;
    @Input() columnOptions: ITableColumn;
}
